import {useCallback, useState} from 'react';
import ReactDOM from 'react-dom';

type ShadowContentProps = {
    container: Element;
    children: React.ReactElement;
}

export const ShadowContent: React.FC<ShadowContentProps> = ({container, children}: ShadowContentProps) =>
    ReactDOM.createPortal(children, container);

type Props = {
    children: React.ReactElement;
    className?: string;
}

export const ShadowView: React.FC<Props> = ({children, className}: Props) => {
    const [container, setContainer] = useState(null);
    const setRef = useCallback((element: HTMLDivElement) => {
        setContainer(element ? element.attachShadow({mode: 'open'}) : null);
    }, []);

    return (
        <div ref={setRef} className={className}>
            {container && <ShadowContent container={container}>{children}</ShadowContent>}
        </div>
    );
};
